<template>
  <div class="header">
      <div class="logo">
        <a @click="$route.name == 'home' ? null : $router.push('/')">
          <img src="../assets/logo.png" />
        </a>
      </div>

      <!-- <div>
        <button v-if="$store.state.coach" @click="$router.push('/prospectdays')">Add Prospect Days</button>
        <button v-if="$store.state.coach" @click="$router.push('/profile')">Profile</button>
        <button v-if="$store.state.coach" @click="logout">Logout</button>
      </div> -->

      <div class="page-title">
        <h1>{{$route.name}}</h1>
      </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
    display: flex;
    flex-wrap: wrap;
    border-left: 1px solid #707070;
}

.header .logo {
    background: #fff;
    width: 20.7777%;
    padding: 34px;
    border: 1px solid #707070;
}

.header .logo img {
    width: 100%;
    height: 100%;
}

.header .page-title {
    background: #002F53;
    width: 79.2222%;
    position: relative;
    border: 1px solid #707070;
    text-transform: capitalize;
    height: 104px;
}

.header .page-title h1 {
    color: #fff;
    font-size: 38px;
    position: absolute;
    text-align: center;
    left: 0;
    right: 0;
    bottom: 10px;
}
</style>